import { render } from "./ErrorMessage.vue?vue&type=template&id=e3232bfc&scoped=true"
const script = {}

import "./ErrorMessage.vue?vue&type=style&index=0&id=e3232bfc&scoped=true&lang=sass"

import exportComponent from "/Users/nika/Documents/Projects/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3232bfc"]])

export default __exports__